
import React from 'react';
import { getAbielAvatarUrl } from '@/utils/storage';
import ImageManager from '@/components/media/ImageManager';

interface AbielAvatarProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

export default function AbielAvatar({ size = 'md', className }: AbielAvatarProps) {
  const sizeClasses = {
    xs: 'h-4 w-4',
    sm: 'h-8 w-8',
    md: 'h-12 w-12', 
    lg: 'h-16 w-16'
  };

  return (
    <ImageManager
      src={getAbielAvatarUrl()}
      alt="Abiel - AI Prayer Assistant"
      type="avatar"
      className={`${sizeClasses[size]} ${className || ''}`}
    />
  );
}
